export class Drawing {
  drawingId: string;
  name: string;
  mediaItemDetailsId: string;

  public json(): any {
    return this;
  }

  loadFromJson(data: any) {
    this.drawingId = data.drawingId;
    this.name = data.name;
    this.mediaItemDetailsId = data.mediaItemDetailsId;
  }
}
